import * as z from 'zod';
import { ContractSuretyType, SuretyBondIssuanceMethod } from '../../../../enums.mjs';
import { Create as Create$1 } from './contract-surety-bond-issuance-mixins.dto.mjs';

var Create;
(function (Create) {
    (function (Request) {
        const baseSchema = Create$1.Request.baseSchema.extend({
            contractSuretyType: z.literal(ContractSuretyType.bid_to_final),
        });
        const dataSchema = Create$1.Request.baseDataSchema.extend({
            contractDescription: z.string(),
        });
        Request.schema = z.discriminatedUnion("issuanceMethod", [
            baseSchema.extend({
                issuanceMethod: z.literal(SuretyBondIssuanceMethod.agent),
            }),
            baseSchema.extend({
                issuanceMethod: z.literal(SuretyBondIssuanceMethod.electronic),
                data: dataSchema,
            }),
            baseSchema.extend({
                issuanceMethod: z.literal(SuretyBondIssuanceMethod.physical),
            }),
        ]);
    })(Create.Request || (Create.Request = {}));
})(Create || (Create = {}));

export { Create };
